import styled, { useTheme } from 'styled-components';

// import HotelsPNG from '../../../assets/hotels.png';
// import ConstructionPNG from '../../../assets/construction.png';
// import SMEsPNG from '../../../assets/smes.png';
import { Button, Flex, Typography } from '../../designComponents';
import { ContainerStyled } from './ProfessionalSlogan/style';

export const UserTypeSectionStyled = styled.section`
  padding: 80px 0;
`;

export const UserTypeCardStyled = styled.div`
  flex: 1 1 280px;
  max-width: 350px;
  background: ${({ theme }) => theme.colors.white};
  padding: 30px;
  border-radius: 20px;
  text-align: center;

  ul {
    list-style: none;
    padding: 0;
    margin: 15px 0 0;
    li {
      margin-bottom: 10px;
      &:before {
        content: '•';
        margin-right: 8px;
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  .user-type-img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin-bottom: 15px;
  }
`;

const UserTypeSection = () => {
  const theme = useTheme();

  const userTypes = [
    {
      title: 'Hotels & Accommodation',
      emoji: '🏨',
      description: [
        'Guest safety',
        'Fire officer inspections',
        'Reception & corridor signage',
        'Multi-floor buildings handled',
      ],
      cta: 'Upload Hotel Plans',
    //   img: HotelsPNG,
    },
    {
      title: 'Construction Companies',
      emoji: '🏗️',
      description: [
        'Site safety compliance',
        'Temporary & permanent signage',
        'Fast turnaround for inspections',
      ],
      cta: 'Upload Site Drawings',
      //   img: ConstructionPNG,
    },
    {
      title: 'SMEs & Property Managers',
      emoji: '🏢',
      description: [
        'Offices, retail, shared buildings',
        'Insurance & compliance peace of mind',
        'Simple, affordable',
      ],
      cta: 'Upload Building Plans',
      //   img: SMEsPNG,
    },
  ];

  return (
    <UserTypeSectionStyled>
      <ContainerStyled>
        <Typography
          variant="heading"
          strong
          style={{
            textAlign: 'center',
            marginBottom: '50px',
            color: theme.colors.primary,
          }}
        >
          Who We Serve
        </Typography>

        <Flex gap="30px" justifyContent="space-between" wrap="wrap">
          {userTypes.map((type, idx) => (
            <UserTypeCardStyled key={idx}>
              {/* {type.img && (
                <img
                  src={type.img}
                  alt={type.title}
                  className="user-type-img"
                />
              )} */}
              <Typography
                variant="title"
                strong
                style={{ margin: '15px 0 10px' }}
              >
                {type.emoji} {type.title}
              </Typography>
              <ul>
                {type.description.map((item, i) => (
                  <li key={i}>
                    <Typography>{item}</Typography>
                  </li>
                ))}
              </ul>
              <Flex justifyContent="center" style={{ marginTop: '20px' }}>
                <Button style={{ borderRadius: '28px', padding: '10px 20px' }}>
                  {type.cta}
                </Button>
              </Flex>
            </UserTypeCardStyled>
          ))}
        </Flex>
      </ContainerStyled>
    </UserTypeSectionStyled>
  );
};

export default UserTypeSection;
